
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

// Production Supabase configuration - secure hardcoded values
const SUPABASE_URL = 'https://jkeglhratnheunfocnbe.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImprZWdsaHJhdG5oZXVuZm9jbmJlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDEzODM5MzYsImV4cCI6MjA1Njk1OTkzNn0.yjJhoeD77xpyoM_B6pLWsWeyCWptXfGo6fw9B7XC9lU';

// Validate required configuration
if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error('Missing required Supabase configuration');
}

// Create the Supabase client
export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_ANON_KEY);

export const fetchGuidanceForRequirement = async (requirementId: string) => {
  try {
    console.log('Fetching guidance for requirement ID:', requirementId);
    
    const { data: requirement, error: reqError } = await supabase
      .from('requirements')
      .select('identifier, standard_id, section, subsection, standard_short_name')
      .eq('id', requirementId)
      .single();
    
    if (reqError || !requirement) {
      console.error('Error fetching requirement:', reqError);
      return null;
    }
    
    console.log('Found requirement:', requirement);
    
    if (!requirement.identifier) {
      console.error('Requirement has no identifier');
      return null;
    }
    
    // Try to use standard_short_name first if available
    let standard = requirement.standard_short_name;
    
    // If standard_short_name is not available, extract from identifier (e.g., REQ_GS37_2.1.7)
    if (!standard) {
      const standardMatch = requirement.identifier.match(/_([^_]+)_/);
      standard = standardMatch ? standardMatch[1] : null;
    }
    
    // Extract section from the identifier (e.g., REQ_GS37_2.1.7)
    const sectionMatch = requirement.identifier.match(/_[^_]+_(\d+\.\d+)/);
    let section = sectionMatch ? sectionMatch[1] : null;
    
    // If section not found in identifier, try to use the section field
    if (!section && requirement.section) {
      section = requirement.section;
    }
    
    if (!standard || !section) {
      console.error('Could not extract standard or section:', {
        identifier: requirement.identifier, 
        standard,
        section
      });
      return null;
    }
    
    // Remove ALL hyphens from the standard name before constructing the ID
    const standardWithoutHyphens = standard.replace(/-/g, '');
    
    // Construct the guidance ID in the format: "STANDARD-SECTION"
    // For example, "GS37-2.1" 
    const guidanceId = `${standardWithoutHyphens}-${section}`;
    
    console.log('Looking for guidance with ID:', guidanceId);
    
    const { data: guidance, error: guidanceError } = await supabase
      .from('guidance')
      .select('*')
      .eq('guidance_id', guidanceId)
      .maybeSingle();
    
    if (guidanceError) {
      console.error('Error fetching guidance:', guidanceError);
      return null;
    }
    
    console.log('Found guidance:', guidance);
    return guidance;
  } catch (error) {
    console.error('Exception in fetchGuidanceForRequirement:', error);
    return null;
  }
};
